<template>
  <div>
    <base-header type class="rsgradient pb-3 pb-1 pt-3 pt-md-5"></base-header>

    <b-card style="margin: 20px">
      <b-card-body>
        <div class="row form-group">
          <div class="col-md-12">
            <label>Nombre Sucursal</label>
            <base-input v-model="SucursalName" readonly></base-input>
          </div>
        </div>

        <div class="row" v-if="this.Editando">
          <div class="col-md-12">
            <button class="btn btn-warning" type="button" @click="nuevo()">
              <i class="fa fa-plus fa-fw"></i>
              Nuevo
            </button>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12" style="margin-top: 5px">
            <label>{{this.ActionText}} Caja</label>
          </div>
          <div class="col-md-12">
            <input v-model="CajaName" placeholder="Nombre..." type="text" class="form-control" />
          </div>

          <div class="col-md-12" style="margin-top: 5px">
            <button class="btn btn-warning" type="button" @click="addCaja()">{{this.ActionText}}</button>
          </div>
        </div>

        <div class="row form-group right"></div>
        <div class="row form-group" v-if="Cajas.length>0">
          <div class="col-md-12">
            <div style="background-color: white; border-radius: 5px; border: #d6d4d4 1px solid">
              <div
                class="row"
                v-for="item in Cajas"
                v-bind:key="item.EntityID"
                :value="item.EntityID"
                style="padding: 5px; border-bottom: 1px solid #d6d4d4; cursor: pointer; margin-right: 0; margin-left: 0"
              >
                <div class="col-lg-12 col-md-12">
                  <span
                    style="margin-left: 10px;margin-top: 25px; font-size:42px; float:left;"
                    class="fa fa-fw fa-cash-register"
                  />
                  <div style="margin-left: 10px;margin-top: 20px; margin-bottom:22px; float:left;">
                    <div>{{item.Name}}</div>
                  </div>
                  <button
                    type="button"
                    @click="exportarQR(item)"
                    class="btn btn-warning"
                    style="border-bottom:10px;max-width:150px;min-width:150px;margin-left: 10px;margin-top: 35px;float:right"
                  >
                    <i class="fa fa-qrcode fa-fw"></i>QR
                  </button>
                  <button
                    type="button"
                    @click="itemClicked(item)"
                    class="btn btn-danger"
                    style="border-bottom:10px;max-width:150px;min-width:150px;margin-left: 10px;margin-top: 35px;float:right"
                  >
                    <i class="fa fa-trash fa-fw"></i>Quitar
                  </button>

                  <button
                    type="button"
                    @click="editClicked(item)"
                    class="btn btn-primary"
                    style="border-bottom:10px;max-width:150px;min-width:150px;margin-left: 10px;margin-top: 35px;float:right"
                  >
                    <i class="fas fa-edit"></i>Editar
                  </button>

                  <button
                    type="button"
                    v-if="item.CanOperate == false"
                    @click="enableCashBoxClick(item.EntityID)"
                    class="btn btn-primary"
                    style="border-bottom:10px;max-width:150px;min-width:150px;margin-left: 10px;margin-top: 35px;float:right;background-color:green"
                  >Habilitar</button>
                  <button
                    type="button"
                    v-if="item.CanOperate"
                    @click="enableCashBoxClick(item.EntityID)"
                    class="btn btn-primary"
                    style="border-bottom:10px;max-width:150px;min-width:150px;margin-left: 10px;margin-top: 35px;float:right;background-color:red"
                  >Deshabilitar</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row form-group">
          <div class="col-md-12">
            <button @click="goBack" class="btn btn-danger btn-lg">Volver</button>
          </div>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import axiosHelpers from "@/helpers/axiosHelpers";
import notificationHelpers from "@/helpers/notificationHelpers";
import fileHelpers from "@/helpers/fileHelpers";
import KitsBusquedaSimple from "@/components/KitsBusquedaSimple";
import KitsCombo from "@/components/KitsCombo";

export default {
  name: "administrarcaja",
  props: {
    EntityIDProp: Number,
    SucursalNameProp: String
  },
  directives: {},
  components: { KitsBusquedaSimple, KitsCombo },

  data() {
    return {
      EntityID: this.EntityIDProp,
      Cajas: [],
      CajaName: "",
      SucursalName: this.SucursalNameProp,
      CashBoxID: null,
      ActionText: "Agregar",
      Editando: false
    };
  },
  methods: {
    isUpdate() {
      return this.EntityID > 0;
    },

    goBack() {
      this.$router.push("sucursales");
    },

    getData() {
      let self = this;

      axiosHelpers.axiosPost(
        "Commerce/GetCashboxFromBranchOffice",
        { BranchOfficeID: self.EntityID },
        this,
        function(data) {
          self.Cajas = data.ResponseVM.CashBoxs;
        }
      );
    },
    addCaja() {
      let self = this;

      if (
        self.CajaName == undefined ||
        self.CajaName == null ||
        self.CajaName == ""
      ) {
        notificationHelpers.showError(
          "Alerta!",
          "Debe seleccionar un nombre para la caja",
          self
        );
        return;
      }

      axiosHelpers.axiosPost(
        "Commerce/CreateCashBox",
        {
          Name: self.CajaName,
          BranchOfficeID: self.EntityID,
          CashBoxID: self.CashBoxID
        },
        this,
        function(response) {
          var hasError = axiosHelpers.getResponseHasErrors(response);
          if (!hasError) {
            self.getData();
            self.CajaName = "";
          }
        }
      );
    },
    exportarQR(item) {
      let context = this;
      axiosHelpers.axiosGet(
        "Account/ExportAccountQR",
        { CashBoxID: item.EntityID },
        this,
        function(data) {
          var bytesBase64 = data.ResponseVM.ReportBytes;

          var fileName = "QRCaja.pdf";
          var appType = "application/pdf";

          fileHelpers.downloadFile(context, bytesBase64, fileName, appType);
        }
      );
    },
    itemClicked(item) {
      //-- Navegamos a gestion de sucursal
      let self = this;

      axiosHelpers.axiosPost(
        "Commerce/RemoveCashBox",
        { CashBoxID: item.EntityID },
        this,
        function(response) {
          var hasError = axiosHelpers.getResponseHasErrors(response);
          if (!hasError) {
            self.Cajas.splice(self.Cajas.indexOf(item), 1);
          }
        }
      );
    },
    nuevo() {
      this.Editando = false;
      this.CashBoxID = null;
      this.CajaName = "";
      this.ActionText = "Agregar";
    },
    editClicked(item) {
      this.CajaName = item.Name;
      this.CashBoxID = item.CashBoxID;
      this.ActionText = "Editar";
      this.Editando = true;
    },
    getDataToRequest() {
      return {
        EntityID: this.EntityID,
        Name: this.Name,
        CityID: this.City.ID,
        Street: this.Street,
        Number: this.Num,
        Local: this.Local,
        CashBoxes: this.Cajas
      };
    },
    enableCashBoxClick(EntityID) {
      let self = this;

      axiosHelpers.axiosPost(
        "Commerce/EnableCashBox",
        { EntityID: EntityID },
        self,
        function(response) {
          if (response.ResponseVM.Success) {
            self.getData();
          }
        }
      );
    }
  },
  beforeMount() {
    this.getData();
  }
};
</script>
<style></style>
